import { ChartBoxover } from '../../../../../app/shared/components/ChartBoxover'
import { ETFHoldingsStandardRowData } from '../types'

interface PortfolioTableColumnProps {
  rowData: ETFHoldingsStandardRowData
}

export function TableNameColumn(props: React.PropsWithChildren<PortfolioTableColumnProps>) {
  const { ticker, name } = props.rowData
  return (
    <td className="truncate px-1.5 py-0">
      {ticker ? (
        <ChartBoxover
          entry={{
            ...props.rowData,
            ticker: ticker ?? '',
            company: name,
          }}
          offsetY={45}
        >
          <a href={`/quote.ashx?t=${ticker}`} target="_blank" className="tab-link">
            {name}
          </a>
        </ChartBoxover>
      ) : (
        name
      )}
    </td>
  )
}
